module.exports = __webpack_public_path__ + "static/media/addItem.54a0c008.svg";